import { useQuery } from '@tanstack/vue-query'
import { computed } from 'vue'
import type { Emoji } from '#features/emoji-selection'
import { emojiConfigQueryOptions } from './emoji-config-query'

export function useEmojiByChar() {
  const emojiConfigQuery = useQuery(emojiConfigQueryOptions)
  const emojiConfig = computed(() => emojiConfigQuery.data.value ?? [])

  const emojiByChar = computed(() => {
    const emojiByChar = new Map<string, Emoji>()
    emojiConfig.value.forEach(category => {
      category.content.forEach(subcategory => {
        subcategory.content.forEach(emoji => {
          emojiByChar.set(emoji.char, emoji)
        })
      })
    })

    return emojiByChar
  })

  return emojiByChar
}
